// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// Translate
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from '../../partials/partials.module';
// Services
import { HttpUtilsService, TypesUtilsService, LayoutUtilsService} from '../../../core/_base/crud';
// Shared
import { ActionNotificationComponent } from '../../partials/content/crud';

// Components
import { SilosEditComponent } from './silos/silos-edit/silos-edit.component'
import { SilosListComponent } from './silos/silos-list/silos-list.component'
import { MachinesListComponent } from './machines/machines-list/machines-list.component';
import { ShiftsEditComponent } from './shifts/shifts-edit/shifts-edit.component';
import { ShiftsListComponent } from './shifts/shifts-list/shifts-list.component';
import { ProductEditComponent } from './product/product-edit/product-edit.component';
import { ProductListComponent } from './product/product-list/product-list.component';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatExpansionModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
} from '@angular/material';
import { PlantConfigurationComponent } from './plant-configuration.component';
import { 
	SiloEffects, 
	silosReducer, 
	machinesReducer,
	// MachineEffects,
	MachineService,
	machineTypesReducer,
	productTypesReducer,
	productsReducer,
	ProductService,
	machineTechTypesReducer,
	shiftsReducer,
	ShiftEffects,
	ShiftService,
	shiftTypesReducer,
	productVarietiesReducer,
	quartelsReducer,
	QuartelEffects,
	QuartelService
} from '../../../core/plant-configuration';
import { MachinesEditComponent } from './machines/machines-edit/machines-edit.component';
import { RoleGuard } from '../../../core/auth/_guards/role.guard';
import { PlantListComponent } from './plants/plants-list/plant-list.component';
import { PlantEditComponent } from './plants/plants-edit/plant-edit.component';
import { ProductTypeService } from '../../../core/plant-configuration/_services/product-type.service';
import { ProductPackageService } from '../../../core/plant-configuration/_services/product-package.service';
import { ProductPackageUnitService } from '../../../core/plant-configuration/_services/product-package-unit.service';
import { ProductPackageWeightService } from '../../../core/plant-configuration/_services/product-package-weight.service';
import { ProductProcessService } from '../../../core/plant-configuration/_services/product-process.service';
import { OperatorService } from '../../../core/plant-configuration/_services/operator.service';
import { OperatorListComponent } from './operators/operators-list/operator-list.component';
import { OperatorEditComponent } from './operators/operators-edit/operator-edit.component';
import { ProductionLineService } from '../../../core/plant-configuration/_services/production-line.service';
import { ProductionLineListComponent } from './production-line/production-line-list/production-line-list.component';
import { ProductionLineEditComponent } from './production-line/production-line-edit/production-line-edit.component';
import { DetentionTypeService } from '../../../core/plant-configuration/_services/detention-type.service';
import { DetentionService } from '../../../core/production/_services/detention.service';
import { DetentionTypeListComponent } from './detention-type/detention-type-list/detention-type-list.component';
import { DetentionTypeEditComponent } from './detention-type/detention-type-edit/detention-type-edit.component';
import { QualityTypeService } from '../../../core/plant-configuration/_services/quality-type.service';
import { QualityTypeListComponent } from './quality-type/quality-type-list/quality-type-list.component';
import { QualityTypeEditComponent } from './quality-type/quality-type-edit/quality-type-edit.component';
import { MachineTechTypeService } from '../../../core/plant-configuration/_services/machine-tech-type.service';
import { MachineTypeService } from '../../../core/plant-configuration/_services/machine-type.service';
import { MachineSensorPortService } from '../../../core/plant-configuration/_services/machine-sensor-port.service';
import { MachineSensorService } from '../../../core/plant-configuration/_services/machine-sensor.service';
import { WorkOrderService } from '../../../core/plant-configuration/_services/work-order.service';
import { WorkOrderListComponent } from './work-orders/work-order-list/work-order-list.component';
import { WorkOrderEditComponent } from './work-orders/work-order-edit/work-order-edit.component';
import { LotService } from '../../../core/plant-configuration/_services/lot.service';


const routes: Routes = [
	{
		path: '',
		component: PlantConfigurationComponent,
		canActivateChild: [RoleGuard],
		children: [
			{
				path: 'work-orders/add',
				component: WorkOrderEditComponent
			},
			{
				path: 'work-orders/edit/:id',
				component: WorkOrderEditComponent
			},
			{
				path: 'work-orders',
				component: WorkOrderListComponent
			},
			{
				path: '',
				redirectTo: 'pavilion',
				pathMatch: 'full'
			},
			{
				path: 'silos',
				component: SilosListComponent
			},
			{
				path: 'silos:id',
				component: SilosListComponent
			},
			{
				path: 'silos/add',
				component: SilosEditComponent,
				//// canActivate: [RoleGuard],
				data: {
					groups: [1]
				}
			},
			{
				path: 'silos/add/:id',
				component: SilosEditComponent,
				//// canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'silos/edit',
				component: SilosEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'silos/edit/:id',
				component: SilosEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'machines',
				component: MachinesListComponent
			},
			{
				path: 'machines:id',
				component: MachinesListComponent
			},
			{
				path: 'machines/add',
				component: MachinesEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'machines/edit',
				component: MachinesEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'machines/edit/:id',
				component: MachinesEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},


			{
				path: 'product',
				component: ProductListComponent
			},
			{
				path: 'product:id',
				component: ProductListComponent
			},
			{
				path: 'product/add',
				component: ProductEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'product/edit',
				component: ProductEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'product/edit/:id',
				component: ProductEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'shifts',
				component: ShiftsListComponent
			},
			{
				path: 'shifts:id',
				component: ShiftsListComponent
			},
			{
				path: 'shifts/add',
				component: ShiftsEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'shifts/edit',
				component: ShiftsEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'shifts/edit/:id',
				component: ShiftsEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'plants',
				component: PlantListComponent
			},
			{
				path: 'plants/add',
				component: PlantEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'plants/edit',
				component: PlantEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'plants/edit/:id',
				component: PlantEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'operators',
				component: OperatorListComponent
			},
			{
				path: 'operators/add',
				component: OperatorEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'operators/edit',
				component: OperatorEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'operators/edit/:id',
				component: OperatorEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'production-line',
				component: ProductionLineListComponent
			},
			{
				path: 'production-line/add',
				component: ProductionLineEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'production-line/edit',
				component: ProductionLineEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'production-line/edit/:id',
				component: ProductionLineEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'detention-type',
				component: DetentionTypeListComponent
			},
			{
				path: 'detention-type/add',
				component: DetentionTypeEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'detention-type/edit',
				component: DetentionTypeEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'detention-type/edit/:id',
				component: DetentionTypeEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'quality-type',
				component: QualityTypeListComponent
			},
			{
				path: 'quality-type/add',
				component: QualityTypeEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'quality-type/edit',
				component: QualityTypeEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
			{
				path: 'quality-type/edit/:id',
				component: QualityTypeEditComponent,
				//canActivate: [RoleGuard],
				data: {
					groups: [1, 4]
				}
			},
		]
	}
];


@NgModule({
	declarations: [
		PlantConfigurationComponent,
		SilosEditComponent,
		SilosListComponent,
		MachinesListComponent,
		ShiftsEditComponent,
		ShiftsListComponent,
		ProductEditComponent,
		ProductListComponent,
		MachinesEditComponent,
		PlantListComponent,
		PlantEditComponent,
		OperatorEditComponent,
		OperatorListComponent,
		ProductionLineListComponent,
		ProductionLineEditComponent,
		DetentionTypeListComponent,
		DetentionTypeEditComponent,
		QualityTypeEditComponent,
		QualityTypeListComponent,
		WorkOrderListComponent,
		WorkOrderEditComponent
	  ],
  imports: [
    CommonModule,
    // HttpClientModule,
	PartialsModule,
	RouterModule.forChild(routes),
	StoreModule.forFeature('silos', silosReducer),
	EffectsModule.forFeature([SiloEffects]),
	StoreModule.forFeature('machines', machinesReducer),
	StoreModule.forFeature('machineTypes', machineTypesReducer),
	StoreModule.forFeature('machineTechTypes', machineTechTypesReducer),
	// EffectsModule.forFeature([MachineEffects]),
	// StoreModule.forFeature('products', productsReducer),
	// StoreModule.forFeature('productTypes', productTypesReducer),
	// StoreModule.forFeature('productVarieties', productVarietiesReducer),
	// EffectsModule.forFeature([ProductEffects]),
	// StoreModule.forFeature('quartels', quartelsReducer),
	// EffectsModule.forFeature([QuartelEffects]),
	StoreModule.forFeature('shifts', shiftsReducer),
	StoreModule.forFeature('shiftTypes', shiftTypesReducer),
	EffectsModule.forFeature([ShiftEffects]),
    FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
    MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule,
	NgbModule
  ],
  providers: [
		// InterceptService,
		// {
        // 	provide: HTTP_INTERCEPTORS,
       	//  	useClass: InterceptService,
		// 	multi: true
		// },
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				panelClass: 'kt-mat-dialog-container__wrapper',
				height: 'auto',
				width: '900px'
			}
		},
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		MachineService,
		ProductService,
		ShiftService,
		QuartelService,
		ProductTypeService,
		ProductPackageService,
		ProductPackageUnitService,
		ProductPackageWeightService,
		ProductProcessService,
		OperatorService,
		ProductionLineService,
		DetentionTypeService,
		DetentionService,
		QualityTypeService,
		MachineTechTypeService,
		MachineTypeService,
		MachineSensorPortService,
		MachineSensorService,
		WorkOrderService,
		LotService
  ],
  entryComponents: [
		ActionNotificationComponent,
		SilosEditComponent,
		ProductEditComponent,
		MachinesEditComponent,
		ShiftsEditComponent
  ],
})
export class PlantConfigurationModule { }
